import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { Utils, NumberFormatter, i18n, DateFormatter, isAuth } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';
import { AppConstants } from '../../constants/AppConstants';
import ProdottoTable from './prodottoTable.jsx';


class ProdottoVersioniList extends React.Component {
    constructor(props) {
        super(props);
        // this.detailsOnClick = this.detailsOnClick.bind(this);
        this.componentName = '[ProdottoVersioniList.jsx]';
        this.createProdotto = this.createProdotto.bind(this);
        this.inputChangeHandlerProdottoSearch = this.inputChangeHandlerProdottoSearch.bind(this);
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //effettuo la chimata rest per recuperare i dati
        this.props.clearAllDatiProdotto().then(
            resolve => {
                this.props.getListProdotti();
            },
            reject => {
                console.log(this.componentName + ' clearAllDatiProdotto KO');
            }
        )
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));

            if (nextProps.rows === null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
            }
        }
    }

    createProdotto() {

        this.props.inizializzaCreazioneProdotto().then(
            resolve => {
                this.props.getListCompagnie().then(
                    resolve => {
                        this.props.history.push('/prodotto/create');

                    },
                    reject => {
                        console.log(this.getListCompagnie + ' KO');
                    }
                )
            },
            reject => {
                console.log(this.inizializzaCreazioneProdotto + ' KO');
            }
        );


    }
    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }
    dateFormatterShort(value, row, index) {
        return DateFormatter.dataFormatterShort(value);
    }

    columnDetail(value, row, index) {
        //console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-info fa-fw'/></button>";
        return temp;
    }

    inputChangeHandlerProdottoSearch(e) {
        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;
            this.props.inputChangeHandlerProdottoSearch(id, value);
        }
    }

    detailsOnClick(row, $element, field) {
        console.log(this.componentName + "detailsOnClick [field] " + field);

        this.props.history.push({ pathname: '/prodotto/details', state: { id: row.id } });
    }



    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="card">
                <div className="card-header">
                    {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                        <agui.aButton className="float-right" bs='primary' onClick={this.createProdotto} icon="fa fa-plus" inline={true}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'Nuovo')}  </agui.aButton>
                    }
                    <h3>{i18n('ARM_CORE_PRODUCT.PRODOTTO.VERSIONI_PRODOTTO', 'Versioni Prodotto')}</h3>
                </div>
                <div className="card-body">
                    <div>
                        <div className="row">
                            <div className="col col-sm-4 col-md-4 col-lg-4">
                                <div className="form-group">
                                    <label htmlFor="dataValidita"> {i18n('ARM_CORE_PRODUCT.SHARED.DATA_VALIDITA', 'Data Validità')} </label>
                                    <input className="form-control" type="date"
                                        onChange={this.inputChangeHandlerProdottoSearch}
                                        value={this.props.psp.dataValidita ? DateFormatter.formatDateFromMilisToString(this.props.psp.dataValidita) : ""}
                                        id="dataValidita" name="dataValidita" />
                                </div>
                            </div>
                            <div
                                style={{
                                    marginTop: 30,
                                    marginLeft: 15,
                                }} >

                                <agui.aButton className="float-right" bs='primary' onClick={this.props.searchProdotto} icon="fas fa-search" inline={true}>{i18n('ARM_CORE_PRODUCT.SHARED.CERCA', 'Cerca')} </agui.aButton>
                            </div>
                        </div>

                    </div>


                    {/* <table ref="MyTable" className={AppConstants.CLASS_TABLE} /> */}
                    <ProdottoTable rows={this.props.rows} history={this.props.history}></ProdottoTable>
                </div>
            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getListProdotti() {
            return dispatch(ProdottoActions.getListProdotti());
        },
        clearAllDatiProdotto() {
            return dispatch(ProdottoActions.clearAllDatiProdotto());
        },
        inizializzaCreazioneProdotto() {
            return dispatch(ProdottoActions.inizializzaCreazioneProdotto());
        },
        getListCompagnie() {
            return dispatch(ProdottoActions.getListCompagnie());
        },
        searchProdotto() {
            return dispatch(ProdottoActions.searchProdotto());
        },
        inputChangeHandlerProdottoSearch(id, value) {
            return dispatch(ProdottoActions.inputChangeHandlerProdottoSearch(id, value));
        }

    }
};

function mapStateToProps(state) {
    return {
        rows: state.prodotto.listProdotto,
        psp: state.prodotto.psp
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(ProdottoVersioniList);
